import React from "react";
import { motion } from "framer-motion";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaHome, FaUsers, FaGraduationCap } from "react-icons/fa";
import './style.css';

import Header from '../../components/header';
import Header2 from '../../components/header2';

const AboutPage = () => {
    return (
        <div className="about-page">
            <Header2 />
            <Header />
            <main className="about-content">
                {/* Introducao */}
                <motion.h1
                    className="about-title"
                    initial={{ opacity: 0, y: -40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                >
                    Nossa História
                </motion.h1>

                <motion.p
                    className="about-description"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.9 }}
                >
                    Fundada em [ano], a República [Nome] nasceu com o propósito de acolher estudantes universitários
                    e criar um ambiente de convivência, amizade e aprendizado. Ao longo dos anos, muitos estudantes passaram
                    por aqui, deixando suas histórias e memórias marcadas para sempre.
                </motion.p>

                {/* Linha do tempo */}
                <VerticalTimeline className="about-timeline">
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: "#07223A", color: "#fff" }}
                        contentArrowStyle={{ borderRight: "7px solid #07223A" }}
                        date="[Ano da Fundação]"
                        iconStyle={{ background: "#0779FF", color: "#fff" }}
                        icon={<FaHome />}
                    >
                        <h3 className="vertical-timeline-element-title">Fundação da República</h3>
                        <p>A república foi criada para acolher estudantes de diversas cidades, formando uma grande família.</p>
                    </VerticalTimelineElement>

                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: "#07223A", color: "#fff" }}
                        contentArrowStyle={{ borderRight: "7px solid #07223A" }}
                        date="[Ano]"
                        iconStyle={{ background: "#0779FF", color: "#fff" }}
                        icon={<FaUsers />}
                    >
                        <h3 className="vertical-timeline-element-title">Primeiros Moradores</h3>
                        <p>Os primeiros estudantes se mudaram e deram início a uma tradição de amizade e parceria.</p>
                    </VerticalTimelineElement>

                    <VerticalTimelineElement
                        className="vertical-timeline-element--education"
                        contentStyle={{ background: "#07223A", color: "#fff" }}
                        contentArrowStyle={{ borderRight: "7px solid #07223A" }}
                        date="[Ano]"
                        iconStyle={{ background: "#0779FF", color: "#fff" }}
                        icon={<FaGraduationCap />}
                    >
                        <h3 className="vertical-timeline-element-title">Primeira turma formada</h3>
                        <p>Os primeiros ex-moradores se formaram, deixando um legado para as futuras gerações.</p>
                    </VerticalTimelineElement>
                </VerticalTimeline>
            </main>
        </div>
    );
};

export default AboutPage;
